import { COMMAND_CENTER_PATH, type ModuleState, type SessionPayload } from '@nest-recruit/shared';
import { destinationFor, navItemsFor } from '../../shell/nav-config';

/**
 * Where `/` sends this person instead of drawing the workspace, if anywhere. With Reports and
 * the Recruiter dashboard switched off (§L34's defaults), that's the module bar's first
 * screen: the job list, "My jobs" (JOB-01, R2).
 */
export function landingFor(session: SessionPayload, modules: ModuleState, hasCommandCenter: boolean, hasWorkspace: boolean): string | null {
  if (hasCommandCenter) return COMMAND_CENTER_PATH;
  if (hasWorkspace) return null;
  return navItemsFor(session, modules).map((item) => destinationFor(item, session, modules)).find((to) => to !== '/') ?? null;
}
